import { render, staticRenderFns } from "./ChangePass.vue?vue&type=template&id=4c3290c4&scoped=true&"
import script from "./ChangePass.vue?vue&type=script&lang=ts&"
export * from "./ChangePass.vue?vue&type=script&lang=ts&"
import style0 from "./ChangePass.vue?vue&type=style&index=0&id=4c3290c4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c3290c4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('4c3290c4', component.options)
    } else {
      api.reload('4c3290c4', component.options)
    }
    module.hot.accept("./ChangePass.vue?vue&type=template&id=4c3290c4&scoped=true&", function () {
      api.rerender('4c3290c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/auth/ChangePass.vue"
export default component.exports